import type { BremenaCsvProfile } from './bremena-csv.types';

/**
 * Neověřený profil Portálu stavebníka (oddělený od ČÚZK).
 * Oficiální ukázkový soubor (A24) je nutný pro ověření sloupců — sloupce níže jsou spekulativní.
 */
export const BREMENA_CSV_PROFILE_PORTAL_STAVEBNIKA: BremenaCsvProfile = {
  id: 'portal_stavebnika_v0_unverified',
  target: 'portal_stavebnika',
  version: '0-unverified',
  labelCs: 'CSV Portál stavebníka (neověřeno)',
  descriptionCs:
    'Pomocný export parcel pro Portál stavebníka. Není produkčně ověřený a není důkazem podání žádosti.',
  unverifiedBadgeCs: 'Neověřeno',
  columns: [
    'ku_kod',
    'ku_nazev',
    'kmenove_cislo',
    'poddeleni',
    'stavebni',
    'parcela',
    'lv',
    'vymera_m2',
    'druh_pozemku',
    'route_version',
  ],
  encoding: 'utf-8',
  delimiter: ';',
  verified: false,
};

/**
 * Neověřený profil CSV pro vklad do katastru (ČÚZK) — oddělený od Portálu stavebníka.
 * Sloupce dle plánované dokumentace — stále neověřeno proti produkčnímu vzorku.
 */
export const BREMENA_CSV_PROFILE_CUZK_VKLAD: BremenaCsvProfile = {
  id: 'cuzk_vklad_v0_unverified',
  target: 'cuzk_vklad',
  version: '0-unverified',
  labelCs: 'CSV ČÚZK vklad (neověřeno)',
  descriptionCs:
    'Pomocný datový soubor pro NV ČÚZK. Není návrh na vklad ani důkaz podání — jen neověřený export sloupců.',
  unverifiedBadgeCs: 'Neověřeno',
  columns: [
    'Typ_parcely',
    'Katastralni_uzemi',
    'Kmenove_cislo_parcely',
    'Poddeleni',
    'Vymera_m2',
    'Druh_pozemku',
    'List_vlastnictvi',
  ],
  encoding: 'windows-1250',
  delimiter: ';',
  verified: false,
};

export const BREMENA_CSV_PROFILES: readonly BremenaCsvProfile[] = [
  BREMENA_CSV_PROFILE_PORTAL_STAVEBNIKA,
  BREMENA_CSV_PROFILE_CUZK_VKLAD,
];

export function getBremenaCsvProfile(profileId: string): BremenaCsvProfile | undefined {
  return BREMENA_CSV_PROFILES.find((p) => p.id === profileId);
}

export function getBremenaCsvProfileByTarget(
  target: BremenaCsvProfile['target'],
): BremenaCsvProfile | undefined {
  return BREMENA_CSV_PROFILES.find((p) => p.target === target);
}
